"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfUnreadCountResponseDto = instanceOfUnreadCountResponseDto;
exports.UnreadCountResponseDtoFromJSON = UnreadCountResponseDtoFromJSON;
exports.UnreadCountResponseDtoFromJSONTyped = UnreadCountResponseDtoFromJSONTyped;
exports.UnreadCountResponseDtoToJSON = UnreadCountResponseDtoToJSON;
exports.UnreadCountResponseDtoToJSONTyped = UnreadCountResponseDtoToJSONTyped;
/**
 * Check if a given object implements the UnreadCountResponseDto interface.
 */
function instanceOfUnreadCountResponseDto(value) {
    if (!('unreadCount' in value) || value['unreadCount'] === undefined)
        return false;
    return true;
}
function UnreadCountResponseDtoFromJSON(json) {
    return UnreadCountResponseDtoFromJSONTyped(json, false);
}
function UnreadCountResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'unreadCount': json['unreadCount'],
    };
}
function UnreadCountResponseDtoToJSON(json) {
    return UnreadCountResponseDtoToJSONTyped(json, false);
}
function UnreadCountResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'unreadCount': value['unreadCount'],
    };
}
